export function buildPostScanOrder(res) {
  if (!res?.order) return null;
  return {
    ...res.order,
    popup_shipping_label: res.popup_shipping_label,
    store_type: res.store_type,
    order_cup_direct_shipping: res.order_cup_direct_shipping,
    large_popup: res.large_popup
  };
}

export function needsShipmentFetch(order) {
  return (
    order?.popup_shipping_label &&
    order?.store_type === 'ShippingEasy' &&
    !order?.shipment_id
  );
}

export function getCompletionPopupUrl(order, generalSettings) {
  if (!order) return null;

  if (
    order.popup_shipping_label &&
    order.store_type === 'ShippingEasy' &&
    order.shipment_id
  ) {
    return `http://app.shippingeasy.com/shipments/${parseInt(
      order.shipment_id,
      10
    )}/edit`;
  }

  if (order.order_cup_direct_shipping) {
    const fields = {
      custom_field_one: generalSettings?.custom_field_one,
      custom_field_two: generalSettings?.custom_field_two
    };
    const key = Object.keys(fields).find(name => fields[name] === 'UOID');
    if (key && order.order_info?.[key]) {
      return `https://ship.ordercup.com/pick_and_pack/ship?uoid=${order.order_info[key]}`;
    }
  }

  return null;
}
